import React from 'react';

import { GeojsonFeature } from '@foreflight/webmap/core';
import { GeojsonLayer } from '@foreflight/webmap/react';

interface Props {
    latitude: number;
    longitude: number;
    bearing: number;
}

const OwnshipMapLayer: React.FC<Props> = props => {
    const feature: GeojsonFeature = {
        type: 'Feature',
        properties: {
            icon: 'Airplane',
            rotation: props.bearing,
            size: 1.2,
            color: '#F0AA39',
        },
        geometry: {
            type: 'Point',
            coordinates: [props.longitude, props.latitude],
        },
    };

    return <GeojsonLayer features={[feature]} priority={31} />;
};

export default OwnshipMapLayer;
